// _services/colorService.js
import api from '../../../api/axios';

export const colorService = {
  /**
   * Obtener colores del template
   */
  getColors: async (slug) => {
    try {
      const response = await api.get(`/colors/${slug}`);
      if (response.status === 200 && response.data) {
        return {
          primaryColor: response.data.primaryColor || '#FFFFFF',
          secondaryColor: response.data.secondaryColor || '#FFFFFF',
          textColor: response.data.textColor || '#FFFFFF',
          backgroundColor: response.data.backgroundColor || '#FFFFFF',
        };
      }
      return null;
    } catch (error) {
      console.error('Error al obtener los colores:', error);
      return null;
    }
  },

  /**
   * Guardar colores del template
   */
  saveColors: async (slug, colors) => {
    const token = localStorage.getItem('token');
    const response = await api.post(
      '/colors',
      {
        slug,
        primaryColor: colors.primaryColor,
        secondaryColor: colors.secondaryColor,
        textColor: colors.textColor,
        backgroundColor: colors.backgroundColor,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  /**
   * Colores por defecto
   */
  getDefaultColors: () => ({
    primaryColor: '#9370DB',
    secondaryColor: '#40E0D0',
    textColor: '#FFFFFF',
    backgroundColor: '#0b0b1a',
  }),
};